import React from 'react';
import { useIntl } from 'react-intl';
import { StreamingSource } from 'fym-shared/src/music24/streaming';
import { TypedMemo } from '../../../common/types';
import { streamingStateMessages as messages } from '../streamingStateMessages';
import { StreamingBlock } from '../parts/StreamingBlock';
import { SourceCard } from '../parts/SourceCard';
import { withBrandWord } from '../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from '../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SourcesBlockProps {
  sources: StreamingSource[];
  onOpenCatalog: () => void;
}

/** "Where these numbers come from": one card per connected source (design b1, f1). */
const SourcesBlockComponent: React.FC<SourcesBlockProps> = ({ sources, onOpenCatalog }) => {
  const intl = useIntl();
  return (
    <StreamingBlock
      title={intl.formatMessage(messages.sourcesTitle)}
      meta={intl.formatMessage(messages.sourcesCount, { count: sources.length })}
      moreLabel={intl.formatMessage(messages.manageSources)}
      onMore={onOpenCatalog}
      testId="streaming-block-sources"
    >
      <div className={styles.sourceCards}>
        {sources.map((source) => (
          <SourceCard key={source.integrationType} source={source} onOpenCatalog={onOpenCatalog} />
        ))}
      </div>
      <p className={styles.footnote}>{withBrandWord(intl.formatMessage(messages.sourcesFooter))}</p>
    </StreamingBlock>
  );
};

export const SourcesBlock = TypedMemo(SourcesBlockComponent);
